module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige12-b90964436960cce97bc6084657bff75a.jpg";